import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Formik, Field, Form as FormikForm } from "formik";
import * as Yup from "yup";
import {
  resetPassword,
  validateForgotPasswordToken,
} from "../../api/authentication.api";
import { useNavigate } from "react-router-dom";
import BackToLogin from "../SignIn/BackToLogin";
import { useLocation } from "react-router-dom";
import { t } from "i18next";

const ResetPasswordForm = () => {
  const [passwordVisible1, setPasswordVisible1] = useState(false);
  const [passwordVisible2, setPasswordVisible2] = useState(false);

  const togglePasswordVisibility1 = () => {
    setPasswordVisible1(!passwordVisible1);
  };

  const togglePasswordVisibility2 = () => {
    setPasswordVisible2(!passwordVisible2);
  };
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlToken = params.get("token");

    if (urlToken) {
      const validateToken = async () => {
        try {
          await validateForgotPasswordToken({ token: urlToken });
          setToken(urlToken);
        } catch (error) {
          toast.error(`${ t("failedToValidate")}`);
          // toast.error("Failed to validate token");
        } finally {
        }
      };

      validateToken();
    } else {
      toast.error(`${ t("noTokenProvided")}`);
      // toast.error("No token provided");
    }
  }, []);

  const [passwordValid, setPasswordValid] = useState({
    length: false,
    specialChar: false,
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await resetPassword(
        {
          password: btoa(values.password),
        },
        token
      );

      toast.success(response?.message);
      navigate("/");
    } catch (error) {
      console.log(error);
      toast.error(`${ t("invalidEmailOrPassword")}`);
      // toast.error("Invalid email Or password");
    }

    if (setSubmitting) setSubmitting(false);
    if (resetForm) resetForm();
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .min(8, " ")
      .matches(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]+/, " "),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });

  const handleValidation = (values) => {
    setPasswordValid({
      length: values.password.length >= 8,
      specialChar: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]+/.test(
        values.password
      ),
    });
  };

  return (
    <div className="login-text">
      <div className="text-center lgo-box cursor-pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M19.8337 11.6667V9.33333C19.8337 6.11167 17.222 3.5 14.0003 3.5C10.7787 3.5 8.16699 6.11167 8.16699 9.33333V11.6667M14.0003 16.9167V19.25M10.267 24.5H17.7337C19.6938 24.5 20.6739 24.5 21.4226 24.1185C22.0812 23.783 22.6166 23.2475 22.9522 22.589C23.3337 21.8403 23.3337 20.8602 23.3337 18.9V17.2667C23.3337 15.3065 23.3337 14.3264 22.9522 13.5777C22.6166 12.9191 22.0812 12.3837 21.4226 12.0481C20.6739 11.6667 19.6938 11.6667 17.7337 11.6667H10.267C8.30681 11.6667 7.32672 11.6667 6.57803 12.0481C5.91946 12.3837 5.38403 12.9191 5.04847 13.5777C4.66699 14.3264 4.66699 15.3065 4.66699 17.2667V18.9C4.66699 20.8602 4.66699 21.8403 5.04847 22.589C5.38403 23.2475 5.91946 23.783 6.57803 24.1185C7.32672 24.5 8.30681 24.5 10.267 24.5Z"
            stroke="#344054"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h2 className="text-center logtitle">{t("newPassword")}</h2>
      <p className="ms-2-message text-center">
      {t("differentPassword")}
      </p>
      <div>
        <div className="mb-2 login-msg"></div>
        <Formik
          initialValues={{ confirmPassword: "", password: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validate={handleValidation}
        >
          {({ isSubmitting, values }) => (
            <FormikForm className="mb-3">
              onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission
      handleSubmit(values); // Manually trigger submit
    }
  }}
              <div className="input-text">
                <label htmlFor="password" className="input__label">
                {t("password")}
                </label>
                <div className="position-relative">
                  <Field
                     type={passwordVisible1 ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder={t("passPlaceholder")}
                    className="input__field"
                    autoComplete="off"
                  />
                  <div className="show-pass" onClick={togglePasswordVisibility1}>
                    {passwordVisible1 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#101828"
                      >
                        <path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"></path>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="eyeImg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#101828"
                      >
                        <path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path>
                      </svg>
                    )}

                    {/* <img
                                  
                                  src='/images/private.png'
                                  alt='view'
                                /> */}
                  </div>
                </div>
              </div>
              <div className="input-text">
                <label htmlFor="confirm-password" className="input__label">
                {t("confirmPassword")}
                </label>
                <div className="position-relative">
                  <Field
                    type={passwordVisible2 ? "text" : "password"}
                    id="confirm-password"
                    name="confirmPassword"
                    placeholder="Enter your password"
                    className="input__field"
                    autoComplete="off"
                  />
                  <div className="show-pass" onClick={togglePasswordVisibility2}>
                    {passwordVisible2 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#101828"
                      >
                        <path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"></path>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="eyeImg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#101828"
                      >
                        <path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path>
                      </svg>
                    )}

                    {/* <img
                                  
                                  src='/images/private.png'
                                  alt='view'
                                /> */}
                  </div>
                </div>
              </div>
              <div className="validation-pass">
                <div
                  className={`valid-text ${passwordValid.length && "active"}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <rect width="20" height="20" rx="10" fill="#D0D5DD"></rect>
                    <path
                      d="M6.25 10L8.75 12.5L13.75 7.5"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  {t("leastCharacters")}
                </div>
                <div
                  className={`valid-text ${
                    passwordValid.specialChar && "active"
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <rect width="20" height="20" rx="10" fill="#D0D5DD"></rect>
                    <path
                      d="M6.25 10L8.75 12.5L13.75 7.5"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  {t("containSpecialCharacter")}
                </div>
              </div>
              <div className="mt-4">
                <button
                  type="submit"
                  className="default-btn signinBtn btn btn-primary w-100 d-flex justify-content-center align-items-center gap-2"
                  disabled={isSubmitting}
                >
                  {t("resetPassword")}
                </button>
              </div>
            </FormikForm>
          )}
        </Formik>
        <BackToLogin />
      </div>
    </div>
  );
};

export default ResetPasswordForm;
